import React, { ReactNode } from "react";
import {
  CopyToClipboard as _CopyToClipboard,
  Props,
} from "react-copy-to-clipboard";

import { IgCopyButton } from "@intelligems/ig-theme/IgCopyButton";
import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import Grid from "@mui/material/Grid";
import { SxProps } from "@mui/system";

interface ClipboardCopyProps {
  copyText: string;
  codeFont?: boolean;
  direction?: "row" | "column";
  copyButtonText?: { copy: string; copied: string };
  copyTextSx?: SxProps;
  copyButton?: ReactNode;
  copyTextTitle?: ReactNode;
  showUrl?: boolean;
}

const CopyToClipboard = _CopyToClipboard as unknown as (
  props: Props
) => ReactNode;

export const ClipboardCopy = ({
  copyText,
  codeFont,
  direction,
  copyButtonText,
  copyTextSx,
  copyButton,
  copyTextTitle,
  showUrl = true,
}: ClipboardCopyProps) => {
  return (
    <Grid
      container
      direction={direction || "row"}
      alignItems={"center"}
      justifyContent={"space-between"}
      rowSpacing={2}
      sx={{ maxWidth: "100%" }}
      flexWrap={"nowrap"}
    >
      {(copyTextTitle || showUrl) && (
        <Grid>
          {copyTextTitle && (
            <Grid>
              <IgTypography fontWeight={600}>
                <>{copyTextTitle}</>
              </IgTypography>
            </Grid>
          )}
          {showUrl && (
            <Grid sx={{ overflowX: "scroll" }}>
              <IgTypography variant={"code"}>{copyText}</IgTypography>
            </Grid>
          )}
        </Grid>
      )}
      <Grid>
        {copyButton ? (
          <CopyToClipboard text={copyText}>
            {copyButton as React.ReactElement}
          </CopyToClipboard>
        ) : (
          <IgCopyButton
            color="primary"
            copiedLabel={copyButtonText?.copied ?? "Copied"}
            label={copyButtonText?.copy ?? "Copy"}
            successColorOnCopy
            text={copyText}
            variant="contained"
          />
        )}
      </Grid>
    </Grid>
  );
};
